import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlInputValueAccessorDirective } from './sl-input-value-accessor.directive'
import { SlMoneyCentValueAccessorDirective } from './sl-money-cent-value-accessor.directive';
import { SlCheckboxValueAccessorDirective } from './sl-checkbox-value-accessor.directive';
import { DraggableDirective } from './draggable.directive';
import { SlSelectValueAccessorDirective } from './sl-select-value-accessor.directive';


@NgModule({
  declarations: [
    SlInputValueAccessorDirective, 
    SlMoneyCentValueAccessorDirective, 
    SlCheckboxValueAccessorDirective,
    SlSelectValueAccessorDirective,
    DraggableDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SlInputValueAccessorDirective, 
    SlMoneyCentValueAccessorDirective,
    SlCheckboxValueAccessorDirective,
    SlSelectValueAccessorDirective,
    DraggableDirective
  ]
})
export class DirectivesModule { }